import Button from '../../../../../Button'

import { OPTION_HEIGHT } from './Option.constants'

function Option({ checked, disabled, label, onChange }) {
  function handleClick() {
    onChange()
  }

  return (
    <Button.Contained
      isGrey
      disabled={disabled}
      height={OPTION_HEIGHT}
      isActive={checked}
      text={label}
      onClick={handleClick}
    />
  )
}

export default Option
